import { ComingSoonSrOnly } from '@/v1/sr-only'

const ComingSoon = function name() {
  return (
    <div className='relative'>
      <div className='py-40 text-center'>
        <h1 className={'text-5xl font-extrabold text-secondary'}>Coming Soon</h1>
        <ComingSoonSrOnly />
      </div>
    </div>
  )
}

export default ComingSoon
